import { render, staticRenderFns } from "./permissoes.vue?vue&type=template&id=087769d5&scoped=true&"
import script from "./permissoes.vue?vue&type=script&lang=js&"
export * from "./permissoes.vue?vue&type=script&lang=js&"
import style0 from "./permissoes.vue?vue&type=style&index=0&id=087769d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087769d5",
  null
  
)

export default component.exports